/*
 * LevelStartScreen
 * ==========
 */
import ScreenBase from '../ui/ScreenBase'

export default class LevelStartScreen extends ScreenBase {

    constructor(game, screens) {
        super(game, 'levelStart');

        this.screens = screens;
        this.params = {
            'bg': [0, 0],
            'level': [0, -54],
            'instruction': [-2, 6],
            'begin': [0, 57]
        };

        this.bg = this.addSprite('bg', 'uiScreens', 'uiLevelStartPanel.png');
        this.level = this.addText2('level', 'blue', 'Level 1', 26);
        this.instruction = this.addText2('instruction', 'blue',
            'Wipe clear at least 1 line of\nletter tiles', 16);
        this.begin = this.addTextButton2('begin', 'uiButtonBegin', 'Begin', this.beginClicked);
        this.setInputForAllButtons(false)
    }

    beginClicked(that) {
        ARK_game_arena_connector.fireEventToArena('event_change');

        that.forceOutForAllButtons();
        that.screens.hideScreen()
    }

    onHideEnded() {
        GS.startGame()
    }

    onShowStarted() {
        this.updateView();
        super.onShowStarted()
    }

    onShowEnded() {
        super.onShowEnded();
        if (!GS.isFresh()) {
            setTimeout(GS.setupNextLevel, 250)
        }
    }

    updateView() {
        var goal = GS.isFresh() ? GS.goal : GS.goal + 1;
        var lineText = (goal===1) ? "line" : "lines";
        this.level.setText('Level ' + goal);
        this.instruction.setText('Wipe clear at least ' + goal + ' ' + lineText + '\nof letter tiles')
    }

}
